import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ViewChild, AfterViewInit } from '@angular/core';
import { AuctionFilter } from '../../models/auction-filter';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { skip } from "rxjs/operators";

import { DistributorFilter } from '../../models/distributor-filter';
import { environment } from '../../../../../environments/environment';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-home-main-modal-winner',
  templateUrl: './home-main-modal-winner.component.html',
  styleUrls: ['./home-main-modal-winner.component.sass']
})
export class HomeMainModalWinnerComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  checkedDistributerWinner: number[];

  dt: DataTables.Api;
  modelDistributorFilter: DistributorFilter = new DistributorFilter();
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  dtOptionsDistributorWinners: DataTables.Settings = {};
  dataSetDistributors: any;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService) {
    this.checkedDistributerWinner = [];
  }

  ngOnInit() {
    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'distrWinner' || key === "all") {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedDistributerWinner = [];

            if (key !== "all") {
              this.onAuctionFilter('winner');
            }
          }
        })
    );

    this.subs.push(this.bus.currentClearSearchModalFields$.subscribe(key => {
      if (key === 'modalDistributorMember' || key === 'modalDistributorWinner' || key === 'modalDistributorLogist') {
        console.log(key);
        this.modelDistributorFilter.name = null;
        this.onFieldChange();
      }
    }));

    const that = this;

    this.dtOptionsDistributorWinners = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      deferLoading: 0,
      // scrollY: '400px',
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.search = this.modelDistributorFilter.name;

        that.http.post<DataTablesResponse>(`${apiServer}/distributorIas`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetDistributors = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { orderable: false },
        { data: 'distrName', name: 'distrName' },
      ]
    };
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalWinnerComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalWinnerComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalWinnerComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  onSelectedRowWinner(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalWinnerComponent.onSelectedRowWinner', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedDistributerWinner.push(value);
      } else {
        for (let i = 0; i < this.checkedDistributerWinner.length; i++) {
          if (this.checkedDistributerWinner[i] === value) {
            this.checkedDistributerWinner.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalWinnerComponent.onSelectedRowWinner', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalWinnerComponent.onSelectedRowWinner', _error, null, 'Row selection failed');
      throw _error;
    }
  }
  onSelectingRowsWinner(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalWinnerComponent.onSelectingRowsWinner', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedDistributerWinner.push(item.nativeElement.value);
        } else {
          for (let i = 0; i < that.checkedDistributerWinner.length; i++) {
            if (that.checkedDistributerWinner[i] === item.nativeElement.value) {
              that.checkedDistributerWinner.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalWinnerComponent.onSelectingRowsWinner', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalWinnerComponent.onSelectingRowsWinner', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }


  onAuctionFilter(selectedType: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalWinnerComponent.onAuctionFilter', null, 'Auction filter started');
      
      switch (selectedType) {
        case 'winner':
          {
            this.modelAuctionFilter.distrWinner = this.checkedDistributerWinner.join(",");
            break;
          }
      }

      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalWinnerComponent.onAuctionFilter', null, 'Auction filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalWinnerComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-winner/home-main-modal-winner.component.ts